
























import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import LivingPlace from './LivingPlace.vue'
import { beforeAddTask } from '@/utils/order'
import SprFestModal from '@/components/Modal/SprFestModal.vue'

@Component({
	name: 'addMediateTask',
	components: {
		LivingPlace,
		PageLayout,
		SprFestModal,
	},
})
export default class addTaskPage extends Vue {
	private active: any = '1'

	private get isFirstVisit() {
		return this.active === '1'
	}

	private toggle(i: any) {
		this.active = i
	}

	private prevStep() {
		this.$emit('prevStep')
	}

	private created() {}

	private mounted() {
		beforeAddTask.call(this)
	}
}
